export default __webpack_public_path__ + "static/media/Monday_02.d331d5ad.png";